import { debounce } from '../debounce';
import videoSeek from '../../events/video/seek';
import pushEvent from '../pushEvent';

// Slowly dragging the native timeline scrubber fires many 'seeked' events in
// quick succession (TA4189057) - one per small position change, not one for
// the whole drag. Debounce so only the settled position, after the user
// stops moving, gets reported as ddc.video.seek.
const SEEK_DEBOUNCE_MS = 500;

// Debounced per <video> element (WeakMap), so seeks on one video can't cancel
// a pending seek on another when a page has more than one native video.
const createDebouncedVideoSeek = (win, delay = SEEK_DEBOUNCE_MS) => {
	const debouncers = new WeakMap();

	return (event) => {
		const element = event?.currentTarget;
		if (!element) {
			return undefined;
		}

		if (!debouncers.has(element)) {
			debouncers.set(
				element,
				debounce((eventObject) => pushEvent(win, eventObject), delay)
			);
		}

		debouncers.get(element).run(videoSeek(event));

		return undefined;
	};
};

export default createDebouncedVideoSeek;
